import React, { forwardRef } from 'react'

export const inputThemes = {
  default: {
    className:
      'py-15 px-20 w-full rounded-md border border-body-light placeholder-body-alt',
    wrapperClassName: 'mb-20',
    labelClassName: 'block mb-10',
    errorClassName: 'text-sm-fluid text-negative mt-5'
  },
  quizBuilder: {
    className:
      'px-16 py-12 w-full text-body leading-5 rounded-md border border-body-light focus:outline-none placeholder-body-alt',

    wrapperClassName: 'form-group mb-20',
    labelClassName: 'block mb-8',
    errorClassName: 'text-sm-fluid text-negative mt-5'
  },
  ai: {
    className:
      'px-16 py-12 w-full text-body leading-5 rounded-md border border-body-light focus:outline-none placeholder-body-alt',
    wrapperClassName: 'form-group mb-20',
    labelClassName: 'flex items-center justify-start mb-8',
    errorClassName: 'text-sm-fluid text-negative mt-5'
  }
}

const Input = forwardRef(
  (
    {
      label,
      info,
      error,
      className = inputThemes.default.className,
      wrapperClassName = inputThemes.default.wrapperClassName,
      labelClassName = inputThemes.default.labelClassName,
      errorClassName = inputThemes.default.errorClassName,
      iconLeft,
      iconRight,
      ...props
    },
    ref
  ) => (
    <div className={wrapperClassName}>
      <label>
        {label && (
          <span className={labelClassName}>
            {label}
            {props.required ? (
              <span className="text-negative ml-4">*</span>
            ) : (
              ''
            )}
          </span>
        )}
        {info && (
          <span className="-mt-10 mb-5 flex text-xs text-body-alt">{info}</span>
        )}
        <div className="relative">
          {iconLeft}
          {props.type === 'textarea' ? (
            <textarea className={className} ref={ref} {...props} />
          ) : (
            <>
              <input
                className={className + (props.maxLength ? ' pr-80' : '')}
                type={props.type}
                ref={ref}
                id={props.id}
                {...props}
              />
              {props.maxLength && props.value.length >= props.maxLength - 50 && (
                <div className="absolute top-16 right-12">
                  <p className="text-sm-fluid text-body-alt">
                    {props.value.length}/{props.maxLength}
                  </p>
                </div>
              )}
            </>
          )}
          {iconRight}
        </div>
        {error && (
          <div>
            {error.map((msg) => (
              <p className={errorClassName} key={msg}>
                {msg}
              </p>
            ))}
          </div>
        )}
      </label>
    </div>
  )
)

Input.displayName = 'Input'

export default Input
